import { TagCompany } from "models/TagCompany";
import { TagCompanyProps } from "models/types";
import { BaseServices } from "./baseServices";

export class TagCompanyService extends BaseServices<TagCompanyProps, TagCompany> {
	constructor() {
		super(TagCompany);
	}

	async listAll() {
		return this.list("tag-companies");
	}

	static getInstance() {
		return new TagCompanyService();
	}
}
